import React, { FunctionComponent } from 'react';
import { AspectContainer, HeightContainer, CameraFlash } from './styled';

interface AspectRatioGateProps {
  shouldFlash: boolean;
}

const AspectRatioGate: FunctionComponent<AspectRatioGateProps> = (props) => {
  const { children, shouldFlash } = props;

  return (
    <AspectContainer>
      <HeightContainer>
        {children}
        {shouldFlash && <CameraFlash />}
      </HeightContainer>
    </AspectContainer>
  );
};

export default AspectRatioGate;
